import React from 'react';
import { Modal } from 'antd';
import { useFormContext } from 'react-hook-form';
import { AlertSuccess } from '../../../../util/Alert';
import { useQueryClient } from '@tanstack/react-query';
import moment from 'moment';
import fitMissionServices from '../../../../../services/fit-mission.services';
import LegacyMissionForm from '../form/LegacyMissionForm';

const LegacyMissionModal = ({ open, handleClose }) => {
  const { watch, handleSubmit } = useFormContext();
  const queryClient = useQueryClient();

  const { mutate: createMission } = fitMissionServices.useMutationCreateMission(
    () => {
      queryClient.invalidateQueries({
        queryKey: ['get-mission'],
        refetchType: 'all',
      });
      AlertSuccess('เพิ่มข้อมูลสำเร็จ');
      handleClose();
    },
  );

  const { mutate: editMission } = fitMissionServices.useMutationUpdateMission(
    () => {
      queryClient.invalidateQueries({
        queryKey: ['get-mission'],
        refetchType: 'all',
      });
      AlertSuccess('แก้ไขข้อมูลสำเร็จ');
      handleClose();
    },
  );

  const _HandleSubmit = handleSubmit((data) => {
    const missionData = {
      title: data.title,
      description: data.description,
      image: data.image,
      point: Number(data.point),
      startDate: moment(data.startDate).toDate(),
      endDate: moment(data.endDate).toDate(),
      memberType: data.memberType,
    };

    if (watch('formType') === 'create') {
      createMission(missionData);
    } else if (watch('formType') === 'edit') {
      editMission({ id: data.id, data: missionData });
    }
  });

  return (
    <Modal
      title={watch('formType') === 'create' ? 'เพิ่มภารกิจ' : 'แก้ไขภารกิจ'}
      visible={open}
      onCancel={handleClose}
      okText="บันทึก"
      cancelText="ยกเลิก"
      onOk={_HandleSubmit}
      width={'50vw'}
    >
      <LegacyMissionForm />
    </Modal>
  );
};

export default LegacyMissionModal;
